
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms-and-conditions",
      function () {
        return require("private-next-pages/legal/terms-and-conditions.js");
      }
    ]);
  